var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1f3060;\n      }\n\n      .cls-2 {\n        fill: #18457c;\n      }\n\n      .cls-3 {\n        fill: #eaeaea;\n      }\n\n      .cls-4 {\n        fill: #dcdbdb;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M687.69,1017H247.9l-169.15-169.15V137.41c0-37.37,30.3-67.66,67.66-67.66h541.29c37.37,0,67.66,30.3,67.66,67.66v811.93c0,37.37-30.3,67.66-67.66,67.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M755.36,374.22h-186.07c-37.37,0-67.66,30.3-67.66,67.66v405.97c0,37.37,30.3,67.66,67.66,67.66h186.07V374.22Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.15,340.39h67.66c9.34,0,16.92-7.58,16.92-16.92s-7.58-16.92-16.92-16.92h-67.66c-9.34,0-16.92,7.58-16.92,16.92s7.58,16.92,16.92,16.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M366.3,340.39h270.64c9.34,0,16.92-7.58,16.92-16.92s-7.58-16.92-16.92-16.92h-270.64c-9.34,0-16.92,7.58-16.92,16.92s7.58,16.92,16.92,16.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.15,408.05h67.66c9.34,0,16.92-7.58,16.92-16.92s-7.58-16.92-16.92-16.92h-67.66c-9.34,0-16.92,7.58-16.92,16.92s7.58,16.92,16.92,16.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M366.3,408.05h270.64c9.34,0,16.92-7.58,16.92-16.92s-7.58-16.92-16.92-16.92h-270.64c-9.34,0-16.92,7.58-16.92,16.92s7.58,16.92,16.92,16.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.15,475.71h67.66c9.34,0,16.92-7.58,16.92-16.92s-7.58-16.92-16.92-16.92h-67.66c-9.34,0-16.92,7.58-16.92,16.92s7.58,16.92,16.92,16.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M366.3,475.71h270.64c9.34,0,16.92-7.58,16.92-16.92s-7.58-16.92-16.92-16.92h-270.64c-9.34,0-16.92,7.58-16.92,16.92s7.58,16.92,16.92,16.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M366.3,543.37h270.64c9.34,0,16.92-7.58,16.92-16.92s-7.58-16.92-16.92-16.92h-270.64c-9.34,0-16.92,7.58-16.92,16.92s7.58,16.92,16.92,16.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.15,543.37h67.66c9.34,0,16.92-7.58,16.92-16.92s-7.58-16.92-16.92-16.92h-67.66c-9.34,0-16.92,7.58-16.92,16.92s7.58,16.92,16.92,16.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.15,611.03h67.66c9.34,0,16.92-7.58,16.92-16.92s-7.58-16.92-16.92-16.92h-67.66c-9.34,0-16.92,7.58-16.92,16.92s7.58,16.92,16.92,16.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.15,678.69h67.66c9.34,0,16.92-7.58,16.92-16.92s-7.58-16.92-16.92-16.92h-67.66c-9.34,0-16.92,7.58-16.92,16.92s7.58,16.92,16.92,16.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.15,746.36h67.66c9.34,0,16.92-7.58,16.92-16.92s-7.58-16.92-16.92-16.92h-67.66c-9.34,0-16.92,7.58-16.92,16.92s7.58,16.92,16.92,16.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.15,814.02h67.66c9.34,0,16.92-7.58,16.92-16.92s-7.58-16.92-16.92-16.92h-67.66c-9.34,0-16.92,7.58-16.92,16.92s7.58,16.92,16.92,16.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M366.3,611.03h270.64c9.34,0,16.92-7.58,16.92-16.92s-7.58-16.92-16.92-16.92h-270.64c-9.34,0-16.92,7.58-16.92,16.92s7.58,16.92,16.92,16.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M366.3,678.69h270.64c9.34,0,16.92-7.58,16.92-16.92s-7.58-16.92-16.92-16.92h-270.64c-9.34,0-16.92,7.58-16.92,16.92s7.58,16.92,16.92,16.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M366.3,746.36h270.64c9.34,0,16.92-7.58,16.92-16.92s-7.58-16.92-16.92-16.92h-270.64c-9.34,0-16.92,7.58-16.92,16.92s7.58,16.92,16.92,16.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M366.3,814.02h270.64c9.34,0,16.92-7.58,16.92-16.92s-7.58-16.92-16.92-16.92h-270.64c-9.34,0-16.92,7.58-16.92,16.92s7.58,16.92,16.92,16.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M298.64,238.9h236.81c9.34,0,16.92-7.58,16.92-16.92s-7.58-16.92-16.92-16.92h-236.81c-9.34,0-16.92,7.58-16.92,16.92s7.58,16.92,16.92,16.92Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 417.05,
    cy: 391.13,
    r: 236.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 417.05,
    cy: 374.22,
    r: 236.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M501.63,441.88v153.32c88.96-34.08,152.24-120.05,152.24-220.98h-84.58c-37.37,0-67.66,30.3-67.66,67.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M332.47,357.3c-37.32,0-67.66-30.35-67.66-67.66s30.35-67.66,67.66-67.66,67.66,30.35,67.66,67.66-30.35,67.66-67.66,67.66ZM332.47,255.81c-18.66,0-33.83,15.17-33.83,33.83s15.17,33.83,33.83,33.83,33.83-15.17,33.83-33.83-15.17-33.83-33.83-33.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M501.63,526.46c-37.32,0-67.66-30.35-67.66-67.66s30.35-67.66,67.66-67.66,67.66,30.35,67.66,67.66-30.35,67.66-67.66,67.66ZM501.63,424.97c-18.66,0-33.83,15.17-33.83,33.83s15.17,33.83,33.83,33.83,33.83-15.17,33.83-33.83-15.17-33.83-33.83-33.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M315.56,492.63c-4.33,0-8.66-1.66-11.96-4.96-6.61-6.61-6.61-17.3,0-23.92l202.98-202.98c6.61-6.61,17.3-6.61,23.92,0s6.61,17.3,0,23.92l-202.98,202.98c-3.3,3.3-7.63,4.96-11.96,4.96h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M78.74,847.85h101.49c37.37,0,67.66,30.3,67.66,67.66v101.49l-169.15-169.15Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M958.34,915.51h-372.14c-37.37,0-67.66-30.3-67.66-67.66v-405.97c0-37.37,30.3-67.66,67.66-67.66h372.14c37.37,0,67.66,30.3,67.66,67.66v405.97c0,37.37-30.3,67.66-67.66,67.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M924.51,577.2h-304.47c-18.69,0-33.83-15.14-33.83-33.83v-67.66c0-18.69,15.14-33.83,33.83-33.83h304.47c18.69,0,33.83,15.14,33.83,33.83v67.66c0,18.69-15.14,33.83-33.83,33.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M653.86,712.53h-33.83c-18.69,0-33.83-15.14-33.83-33.83v-33.83c0-18.69,15.14-33.83,33.83-33.83h33.83c18.69,0,33.83,15.14,33.83,33.83v33.83c0,18.69-15.14,33.83-33.83,33.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M789.19,712.53h-33.83c-18.69,0-33.83-15.14-33.83-33.83v-33.83c0-18.69,15.14-33.83,33.83-33.83h33.83c18.69,0,33.83,15.14,33.83,33.83v33.83c0,18.69-15.14,33.83-33.83,33.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M924.51,712.53h-33.83c-18.69,0-33.83-15.14-33.83-33.83v-33.83c0-18.69,15.14-33.83,33.83-33.83h33.83c18.69,0,33.83,15.14,33.83,33.83v33.83c0,18.69-15.14,33.83-33.83,33.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M653.86,847.85h-33.83c-18.69,0-33.83-15.14-33.83-33.83v-33.83c0-18.69,15.14-33.83,33.83-33.83h33.83c18.69,0,33.83,15.14,33.83,33.83v33.83c0,18.69-15.14,33.83-33.83,33.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M789.19,847.85h-33.83c-18.69,0-33.83-15.14-33.83-33.83v-33.83c0-18.69,15.14-33.83,33.83-33.83h33.83c18.69,0,33.83,15.14,33.83,33.83v33.83c0,18.69-15.14,33.83-33.83,33.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M924.51,847.85h-33.83c-18.69,0-33.83-15.14-33.83-33.83v-33.83c0-18.69,15.14-33.83,33.83-33.83h33.83c18.69,0,33.83,15.14,33.83,33.83v33.83c0,18.69-15.14,33.83-33.83,33.83Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEight);
export default __webpack_public_path__ + "static/media/eight.a7de8e43e3a4c3904de7077d828a219c.svg";
export { ForwardRef as ReactComponent };